import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom, map, take } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  normalizeIntegrationRequestsResponse,
  PartnerIntegrationRequest,
  PartnerIntegrationRequestsResponse,
  ReviewPartnerIntegrationRequestDto,
} from '../../../patrol/models/partner-integration.model';

@Injectable({ providedIn: 'root' })
export class PartnerIntegrationReviewService {
  #http = inject(HttpClient);

  listPending(): Promise<PartnerIntegrationRequest[]> {
    return lastValueFrom(
      this.#http
        .get<PartnerIntegrationRequestsResponse>(
          `${environment.baseUrl}/user/identity/admin/integration-requests`,
        )
        .pipe(
          map((response) => normalizeIntegrationRequestsResponse(response)),
          take(1),
        ),
    );
  }

  approve(
    requestId: string,
    dto: ReviewPartnerIntegrationRequestDto = {},
  ): Promise<PartnerIntegrationRequest> {
    return lastValueFrom(
      this.#http
        .post<PartnerIntegrationRequest>(
          `${environment.baseUrl}/user/identity/admin/integration-requests/${encodeURIComponent(requestId)}/approve`,
          dto,
        )
        .pipe(take(1)),
    );
  }

  reject(
    requestId: string,
    dto: ReviewPartnerIntegrationRequestDto = {},
  ): Promise<PartnerIntegrationRequest> {
    return lastValueFrom(
      this.#http
        .post<PartnerIntegrationRequest>(
          `${environment.baseUrl}/user/identity/admin/integration-requests/${encodeURIComponent(requestId)}/reject`,
          dto,
        )
        .pipe(take(1)),
    );
  }

  requestInfo(
    requestId: string,
    dto: ReviewPartnerIntegrationRequestDto,
  ): Promise<PartnerIntegrationRequest> {
    return lastValueFrom(
      this.#http
        .post<PartnerIntegrationRequest>(
          `${environment.baseUrl}/user/identity/admin/integration-requests/${encodeURIComponent(requestId)}/needs-info`,
          dto,
        )
        .pipe(take(1)),
    );
  }
}
